export default __webpack_public_path__ + "static/media/Rule11.1ada7242.png";